// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6OMJj","fullView":"styles_fullView__2Ouc4"};